// extracted by mini-css-extract-plugin
export default {"orderInfoValue":"Base_orderInfoValue__Z03FQ","expired":"Base_expired__93fLk","loading":"Base_loading__qTIsQ"};